import { ActionBase } from '../actions/action-base';
import * as models from '../../shared/models';
import * as sharedDataActions from '../actions/shared-data.action';

/**
 * Interface used to maintain the state for the shared data
 */
export interface SharedDataState {
    sharedData: models.SharedData;
}
/**
 * Variable used to store the initial state of shared data
 */
const initialState: SharedDataState = {
    sharedData: {
        showHeader: true,
        showMenu: true,
        showFooter: true,
        dealerDetails: null,
        token: null,
        vehicleDetails: null,
        showShrinkImage: false,
        tfsFinancingArray: []
    }
}; 
/**
 * Reducer method to handle the shared data actions
 */

// Hack: Ignored tslint errors
/* tslint:disable:no-switch-case-fall-through */
export function reducer(state = initialState, action: ActionBase): SharedDataState {
    switch (action.type) {
        case sharedDataActions.actionTypes.GET_SHARED_DATA:
            {
                return state;
            }
        case sharedDataActions.actionTypes.SET_SHARED_DATA:
            {
                return (<any>Object).assign({}, state,
                    {
                        sharedData: action.payload
                    });
            }
        default: {
            return state;
        }

    }
}
/* tslint:enable:no-switch-case-fall-through */

/**
 * Method to get the state of shared data
 */
export function getSharedData(state: SharedDataState) {
  return state.sharedData;
}


